// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"516":"cde61486","787":"796ad253","985":"c15ee6d2"}[chunkId] + ".chunk.js";
};